import { Outlet } from 'react-router-dom'
import Header from '../components/Header'
/**
 * `DashboardLayout` is a layout component for the dashboard section of the application.
 * It includes a persistent `Header` component and renders child routes using `Outlet`.
 *
 * @returns {JSX.Element} The dashboard layout component.
 */
export default function DashboardLayout() {
    return (
        <>
            {/* Persistent header for the dashboard */}
            <Header />
            {/* Renders the nested routes */}
            <Outlet />
        </>
    )
}
